import { render } from "./TokenSupplyEvents.vue?vue&type=template&id=377867b4&scoped=true"
import script from "./TokenSupplyEvents.vue?vue&type=script&lang=js"
export * from "./TokenSupplyEvents.vue?vue&type=script&lang=js"

import "./TokenSupplyEvents.vue?vue&type=style&index=0&id=377867b4&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377867b4"],['__file',"resources/js/components/TokenSupplyEvents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "377867b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('377867b4', __exports__)) {
    api.reload('377867b4', __exports__)
  }
  
  module.hot.accept("./TokenSupplyEvents.vue?vue&type=template&id=377867b4&scoped=true", () => {
    api.rerender('377867b4', render)
  })

}


export default __exports__